export function point() {
  try {
    // <!--S 腾讯埋点监测基础代码  -->
    !(function (g, d, t, e, v, n, s) {
      if (g.gdt) return
      v = g.gdt = function () {
        v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments)
      }
      v.sv = '1.0'
      v.bt = 0
      v.queue = []
      n = d.createElement(t)
      n.async = !0
      n.src = e
      s = d.getElementsByTagName(t)[0]
      s.parentNode.insertBefore(n, s)
    })(
      window,
      document,
      'script',
      '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js'
    )
  } catch (e) {
    console.log(e)
  }
  // 迁移到接口获取
  // gdt('init', '1111850894');
  // gdt('track', 'PAGE_VIEW');
  // <!--E 腾讯埋点监测基础代码  -->
}
